export enum QuickBetActionsTypeEnum {
	TicketGen = "quick-bet-action-ticket-generation",
	PageVisit = "quick-bet-action-page-visit",
	TicketUse = "quick-bet-action-ticket-use",
}

export enum MostPlayTicketActionsTypeEnum {
	TicketClick = "most-play-tickets-action-ticket-click",
	TicketUse = "most-play-tickets-action-ticket-use",
	PageVisit = "most-play-tickets-action-page-visit",
}

export enum SharedBetSlipActionsTypeEnum {
	TicketClick = "shared-bet-slip-action-ticket-click",
	TicketUse = "shared-bet-slip-action-ticket-use",
	PageVisit = "shared-bet-slip-action-page-visit",
}

export enum BetBuilderPickActionsTypeEnum {
	PickClick = "bet-builder-pick-action-click",
	PickUse = "bet-builder-pick-action-use",
	PageVisit = "bet-builder-pick-action-page-visit",
}
